<template>
  <div>
    <SummaryEvent v-if="summary" :event="event" />

    <DetailEvent v-else :event="event" />
  </div>
</template>

<script>
import DetailEvent from '@/components/requests/overtime/timeline/DetailEvent'
import SummaryEvent from '@/components/requests/overtime/timeline/SummaryEvent'
import OvertimeRequestedEvent from '@/components/requests/overtime/events/OvertimeRequestedEvent'

export default {
  name: 'OvertimeWasRequested',

  components: { SummaryEvent, DetailEvent },

  props: {
    event: {
      type: OvertimeRequestedEvent,
      required: true,
    },

    summary: {
      type: Boolean,
      required: false,
    },
  },
}
</script>
